export class PlayerAddressPending {
  constructor() {
    this.code = null;
    this.address = null;
    this.signature = null;
    this.pubkey = null;
    this.ip = null;
    this.user_agent = null;
    this.permissions = null;
    this.created_at = null;
    this.updated_at = null;
  }
}